module.exports = __webpack_public_path__ + "static/truck-menu-en-2f00b888182ae060cdddecfbaa980f0a.jpg";